<div class="ac-backdrop" (click)="onBackdropClick($event)">
  <div
    #dialog
    class="ac-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="ac-title"
    tabindex="-1"
  >
    <header class="ac-header d-flex align-items-center justify-content-between">
      <h2 id="ac-title" class="ac-title m-0">{{ title }}</h2>
      <button type="button" class="ac-close" aria-label="Close" (click)="close()">
        <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
          <path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </header>

    <ul class="ac-legend list-unstyled d-flex flex-wrap align-items-center">
      <li><span class="ac-swatch ac-swatch--available"></span>Available</li>
      <li><span class="ac-swatch ac-swatch--assigned"></span>Assigned</li>
      <li><span class="ac-swatch ac-swatch--inactive"></span>Inactive</li>
      <li><span class="ac-swatch ac-swatch--selected"></span>Selected</li>
    </ul>

    <div class="ac-grid" role="group" aria-label="Card slots">
      @for (slot of displaySlots(); track $index) {
      @if (slot) {
      <button type="button" class="ac-slot" [class.is-assigned]="slot.status === 'assigned'"
        [class.is-inactive]="slot.status === 'inactive'" [class.is-selected]="selected() === slot.id"
        [disabled]="slot.status !== 'available'"
        [attr.aria-pressed]="slot.status === 'available' ? selected() === slot.id : null"
        [attr.aria-label]="slot.label + ' ' + slot.status" (click)="toggle(slot)">
        {{ slot.label }}
      </button>
      } 
      <!-- @else {
      <span class="ac-slot ac-slot--empty" aria-hidden="true"></span>
      } -->
      }
    </div>

    <footer class="ac-footer d-flex justify-content-center">
      <button type="button" class="btn ac-btn ac-btn--outline" (click)="reset()">
        Reset
      </button>
      <button type="button" class="btn ac-btn ac-btn--primary" [disabled]="!selectedSlot() || loading" (click)="assign()">
        {{ confirmLabel }}
      </button>
      </footer>
  </div>
</div>